import EdiOperator from "@/domains/EdiOperators/EdiOperator";

export default class EdiOperatorConnection {
  ediOperator: EdiOperator;
  externalId: string;

  constructor(ediOperator?: EdiOperator, externalId?: string) {
    if (ediOperator !== undefined && externalId !== undefined) {
      this.ediOperator = ediOperator;
      this.externalId = externalId;
    }
  }

  static fromServer(data: any, result = new EdiOperatorConnection()): EdiOperatorConnection {
    result.ediOperator = EdiOperator.fromServer(data.ediOperator);
    result.externalId = data.externalId;
    return result;
  }

}
